import { products } from '../../../mocks/products';

export function FeaturedProducts() {
  return (
    <section id="featured-products" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.2em] text-gray-500 mb-4">FEATURED PRODUCTS</p>
          <h2 className="text-5xl font-bold text-gray-900 mb-8" style={{ fontFamily: 'Playfair Display, serif' }}>
            Discover Our Favorites
          </h2>
          <div className="w-16 h-0.5 mx-auto" style={{ backgroundColor: '#C67B5C' }}></div>
        </div>

        {/* Product Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {products.map((product) => (
            <div 
              key={product.id}
              className="group cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="rounded-2xl overflow-hidden border border-black/5 bg-white shadow-sm hover:shadow-xl transition-shadow duration-300">
                {/* Image Container */}
                <div className="relative overflow-hidden bg-gray-50" style={{ aspectRatio: '3/4' }}>
                  <img 
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  {product.price && (
                    <div className="absolute top-3 right-3 bg-white rounded-full px-4 py-2 shadow-md">
                      <span className="text-sm font-semibold text-gray-900">${product.price}</span>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-medium text-gray-900 mb-2 truncate">
                    {product.name}
                  </h3>
                  <p className="text-sm text-gray-600 line-clamp-2 leading-relaxed">
                    {product.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}